import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useConsentBanner } from 'src/app/navigation-provider';
import { TOGGLE_SINGLE_FILE_MODE_SETTINGS_HEADER_VISIBILITY } from 'src/redux/pull-request/actions';
import { getCombinedBannerAndHorizontalNavHeight } from 'src/selectors/global-selectors';
import { BucketState } from 'src/types/state';

export const useAnchorTopOffset = () => {
  const { consentBannerHeight } = useConsentBanner()[0];
  return useSelector((state: BucketState) =>
    getCombinedBannerAndHorizontalNavHeight(state, false, consentBannerHeight)
  );
};

export const useSettingsHeaderVisibilityChanged = () => {
  const dispatch = useDispatch();

  return useCallback(
    (isVisible: boolean) =>
      dispatch({
        type: TOGGLE_SINGLE_FILE_MODE_SETTINGS_HEADER_VISIBILITY,
        payload: isVisible,
      }),
    [dispatch]
  );
};
